import axios from "axios";

const axioos = axios.create();
// const hostname = getStore("hostname");

export { axioos };
